import React from 'react';
import { CheckCircle } from 'components/icons';
import styles from '../styles/AIAOffers.module.scss';

const IMAGES = [
  {
    image: `${MARKETING_SITE_URL}/images/q4e/life-1.webp`,
    title: '6 months FREE (via cashback)',
  },
  {
    image: `${MARKETING_SITE_URL}/images/q4e/life-2.webp`,
    title: 'Earn the latest Apple Watch by keeping fit',
  },
  {
    image: `${MARKETING_SITE_URL}/images/q4e/life-3.webp`,
    title: 'Save up to 25% on gym memberships',
  },
  {
    image: `${MARKETING_SITE_URL}/images/q4e/life-4.webp`,
    title: '25-50% discounts on brands & movies',
  },
];

const STARTER_IMAGES = R.update(
  0,
  {
    image: `${MARKETING_SITE_URL}/images/q4e/life-5.webp`,
  },
  IMAGES,
);

export const AIAOffers = ({ images = IMAGES }) => {
  return (
    <div className={styles.images}>
      {images.map((img, idx) => (
        <div key={`offer-${idx}`} className={styles.imgCol}>
          <div className={styles.imgContainer}>
            <img src={img.image} alt={img.title} loading="lazy" />
            <CheckCircle className={styles.imgCheck} />
          </div>
          <p>{img.title}</p>
        </div>
      ))}
    </div>
  );
};

export const AIAStarterOffers = () => {
  return (
    <div className={styles.imagesStarter}>
      {STARTER_IMAGES.map((img, idx) => (
        <div key={`offer-${idx}`} className={styles.imgContainer}>
          <img src={img.image} alt={img.title} loading="lazy" />
          <CheckCircle className={styles.imgCheck} />
        </div>
      ))}
    </div>
  );
};
